import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Container from '../../../Core/Container';

import {
  Banner,
  RatingWrapper,
  StarRating,
  UserCounts,
  Subtext,
  Heading,
  Section,
} from './styles';

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
    [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
  },
};

const RatingBanner = ({ data = null, className = '' }) => {
  if (!data) return null;

  const {
    component,
    appRating,
    appRatingSubtext,
    numberOfUsers,
    numberOfUsersSubtext,
    pointsRedemptionText,
    pointsRedemptionSubtext,
    heading,
    backgroundColor,
  } = data;

  return (
    <Container className={`${className}`} backgroundColor={backgroundColor}>
      <Section className={`${component}`}>
        {heading && <RichText document={heading} options={header} />}
        <Banner className={`${component} ${className}`}>
          <RatingWrapper>
            {numberOfUsers && (
              <UserCounts>{ReactHtmlParser(numberOfUsers)}</UserCounts>
            )}
            {numberOfUsersSubtext && (
              <Subtext>{ReactHtmlParser(numberOfUsersSubtext)}</Subtext>
            )}
          </RatingWrapper>
          <RatingWrapper>
            {pointsRedemptionText && (
              <UserCounts>{ReactHtmlParser(pointsRedemptionText)}</UserCounts>
            )}
            {pointsRedemptionSubtext && (
              <Subtext>{ReactHtmlParser(pointsRedemptionSubtext)}</Subtext>
            )}
          </RatingWrapper>
          <RatingWrapper>
            {appRating && <StarRating>{ReactHtmlParser(appRating)}</StarRating>}
            {appRatingSubtext && (
              <Subtext>{ReactHtmlParser(appRatingSubtext)}</Subtext>
            )}
          </RatingWrapper>
        </Banner>
      </Section>
    </Container>
  );
};

RatingBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default RatingBanner;
